module.exports = "/images/bj.svg?b80abfca439c1e57a9c8bd038d401aa5";